import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { PreInscripcionUIConsumer } from '../../PreInscripcionUIContext';

//Calendario
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';

//BOTONES
import Volver from '../../components/Volver';
import Continuar from '../../components/Continuar';
import Editar from '../../components/Editar';
//import { Button } from 'react-bootstrap';

//Formik
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
//MODAL
//import { Modal } from 'react-bootstrap';

//ISO PAISES/PROVINCIAS
import Countries from '../../../../../../_metronic/countries/Countries';

//Formateo los paises a array
const paises = Countries();
//FECHA HOY
const hoy = new Date();

//EDADES
const mayorTresAños = new Date(hoy.getFullYear() - 3, 6, 1);
const mayorDeEdad = new Date(hoy.getFullYear() - 17, hoy.getMonth(), hoy.getDate());//reponsable mayor a 18 alfre 03/12/2020
const edadMAxima = new Date(hoy.getFullYear() - 100, hoy.getMonth(), hoy.getDate());//edad maxima 100 años juan 04/12/2020

const DatosPersonales = (props) => {
    const { tipo, posicion, setCantidad, setVerDomicilio, verDomicilio } = props;
    const [nombre, setNombre] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [cargo, setcargo] = useState(0);
    registerLocale("es", es)
    const [provincias, setProvincias] = useState([]);
    const datosPersonalesSchema = Yup.object().shape({
        nombre: Yup.string()
            .min(2, "El nombre debe tener 2 caracteres mínimo")
            //.max(maxNombre, `El nombre debe tener ${maxNombre} caracteres máximo`)
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El nombre debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un nombre"),
        apellido: Yup.string()
            .min(2, "El apellido debe tener 2 caracteres mínimo")
            //.max(maxApellido, `El apellido debe tener ${maxApellido} caracteres máximo`)
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El apellido debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un  apellido"),
        pais: Yup.string()
            .required("Debe seleccionar un país"),
        provincia: Yup.string()
            .required(`Debe ${provincias.length > 0 ? "seleccionar" : "ingresar"} una provincia`),
        localidad: Yup.string()
            .min(3, "La localidad debe tener 3 caracteres mínimo")
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "La localidad debe estar compuesta solo por letras")
            .required("Debe ingresar la localidad"),
        fechaNacimiento: Yup.date()
            .min(edadMAxima, `Debe tener fecha de nacimiento mayor al ${edadMAxima.toLocaleDateString("es")}`)
            .max(tipo === "aspirante" ? mayorTresAños : mayorDeEdad, tipo === "aspirante" ?
                `Debe tener fecha de nacimiento menor al ${mayorTresAños.toLocaleDateString("es")}`
                :
                `Debe ser mayor a 18 años para ser responsable de un aspirante`
            )
    });
    const datosPersonalesResponsableSchema = Yup.object().shape({
        vinculo: Yup.string()
            //.matches(/^[A-Za-z\s]+$/, "El vinculo debe estar compuesto solo por letras")
            .required("Debe ingresar el vinculo"),
        email: Yup.string()
            .email("El email ingresado no es valido")
            .required("Debe ingresar el Email"),
        telefono: Yup.string()
            .matches(/^\d+$/, "Solo debe ingresar números")
            .required("Debe ingresar el teléfono")
    }).concat(datosPersonalesSchema);

    const { aspiranteEstado } = useSelector(
        (state) => ({
            aspiranteEstado: state.aspirante.aspiranteInformacion
        }),
        shallowEqual
    );

    useEffect(() => {
        if (aspiranteEstado) {
            setNombre(aspiranteEstado.nombre);
        };
    }, [aspiranteEstado, nombre, cargo]);

    const { pasoUno } = useSelector(
        (state) => ({ pasoUno: state.pasoUno }),
        shallowEqual
    );
    const { responsables } = pasoUno;

    function formularioCompleto(cantidad) {
        setcargo(cargo + 1);
        setDisabled(true);
        setCantidad(cantidad);
        //setVerDomicilio(true);
    };
    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {   tipo === "aspirante" &&
                        value.valoresExtrasAspirante().id > 0 &&
                        cargo === 0 &&
                        formularioCompleto(value.cantidadResponsables())
                    }
                    {   tipo === "responsable" &&
                        responsables.length > 0 &&
                        responsables.length > posicion &&
                        responsables[posicion].email &&
                        responsables[posicion].telefono &&
                        responsables[posicion].vinculo &&
                        cargo === 0 &&
                        formularioCompleto(value.cantidadResponsables())
                    }
                    <div className="d-flex flex-row justify-content-between">
                        <p className="font-weight-bold">Datos personales</p>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>
                    <Formik
                        enableReinitialize
                        initialValues={tipo === "aspirante" ? value.valoresDatosPersonalesAspirante() : value.valoresDatosPersonalesResponsable(posicion)}
                        validationSchema={tipo === "responsable" ? datosPersonalesResponsableSchema : datosPersonalesSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            setTimeout(() => {
                                if (tipo === "aspirante") {
                                    value.dispatchDatosPeronales({ type: 'guardarAspiranteDatosPersonales', payload: values });
                                };
                                if (tipo === "responsable") {
                                    values.posicion = posicion;
                                    const { vinculoId } = value.vinculos.find(item => item.nombre === values.vinculo);
                                    values.vinculoId = vinculoId;
                                    value.dispatchDatosPeronales({ type: 'guardarResponsableDatosPersonales', payload: values });
                                };
                                formularioCompleto(value.cantidadResponsables());
                                setSubmitting(false);
                            }, 400);
                        }}
                    >
                        {formik => (
                            <Form>
                                <>
                                    {!formik.values.localidad && setDisabled(false) && setVerDomicilio(false)}
                                    {disabled && !!formik.values.localidad && formik.values.localidad.length > 0 && setVerDomicilio(true)}
                                    <div className="row justify-content-between align-items-top" >
                                        <div className="form-group col-12 col-sm-6">
                                            <label htmlFor="apellido">Ingresar Apellido*</label>
                                            <Field name="apellido" type="text" className="form-control" placeholder="Apellido" maxLength={value.maxApellido} disabled={disabled || value.validacionRegistroCivil(tipo, posicion)} />
                                            <div className="text-danger"><ErrorMessage name="apellido" /></div>
                                        </div>
                                        <div className="form-group col-12 col-sm-6">
                                            <label htmlFor="nombre">Ingresar Nombre*</label>
                                            <Field name="nombre" type="text" className="form-control" placeholder="Nombre" maxLength={value.maxNombre} disabled={disabled || value.validacionRegistroCivil(tipo, posicion)} />
                                            <div className="text-danger"><ErrorMessage name="nombre" /></div>
                                        </div>
                                    </div>
                                    {tipo === "responsable" &&
                                        <>
                                            <div className="form-group">
                                                <label htmlFor="vinculo">Seleccionar Vinculo*</label>
                                                <Field name="vinculo" type="text" className="form-control" as="select" disabled={disabled} >
                                                    {!formik.values.vinculo ?
                                                        <option value="">Vinculo</option>
                                                        :
                                                        null
                                                    }
                                                    {value.vinculos.map((item, i) =>
                                                        i < 3 &&
                                                        <option className="form-control" key={i} value={item.nombre}>{item.nombre}</option>
                                                    )}
                                                </Field>
                                                <div className="text-danger"><ErrorMessage name="vinculo" /></div>
                                            </div>
                                            <div className="row justify-content-between">
                                                <div className="form-group col-12 col-sm-5 justify-content-bottomm">
                                                    <label htmlFor="email">Ingresar Email*</label>
                                                    <Field
                                                        name="email"
                                                        type="text"
                                                        maxLength={value.maxEmail}
                                                        className="form-control"
                                                        placeholder="Email"
                                                        disabled={disabled}
                                                    />
                                                    <div className="text-danger"><ErrorMessage name="email" /></div>
                                                </div>
                                                <div className="form-group col-12 col-sm-5 justify-content-bottomm">
                                                    <label htmlFor="telefono">Ingresar Número de Teléfono*</label>
                                                    <Field
                                                        name="telefono"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={value.maxTelefono}
                                                        placeholder="Teléfono"
                                                        disabled={disabled}
                                                    />
                                                    <small>Solo números sin puntos o comas</small>
                                                    <div className="text-danger"><ErrorMessage name="telefono" /></div>
                                                </div>
                                            </div>
                                        </>}
                                    <div className="form-group">
                                        <label htmlFor="fechaNacimiento">Fecha de Nacimiento*</label><br />
                                        <div className="d-flex align-items-center">
                                            <DatePicker
                                                disabled={disabled || value.validacionRegistroCivil(tipo, posicion)}
                                                className="form-control"
                                                name="fechaNacimiento"
                                                locale="es"
                                                dateFormat="dd/MM/yyyy"
                                                selected={formik.values.fechaNacimiento}
                                                onChange={date => { formik.setFieldValue("fechaNacimiento", date) }}
                                            />
                                            {formik.values.fechaNacimiento && value.calcularEdad(formik.values.fechaNacimiento) > 0 &&
                                                <b className="ml-3">Edad: {value.calcularEdad(formik.values.fechaNacimiento).toString()} años</b>
                                            }
                                        </div>
                                        <div className="text-danger"><ErrorMessage name="fechaNacimiento" /></div>
                                    </div>
                                    <p className="font-weight-bold">Lugar de Nacimiento</p>
                                    <div className="row justify-content-between align-items-top" >
                                        <div className="form-group col-12 col-sm-4">
                                            <label htmlFor="pais">Seleccionar País*</label>
                                            <Field name="pais" as="select" className="form-control" disabled={disabled && (!!formik.values.localidad && formik.values.localidad.length > 0)}>
                                                {formik.values.pais.length === 0 && <option value="">País</option>}
                                                {paises.map((pais, i) => <option key={i} value={i} >{pais.countryName}</option>)}
                                            </Field>
                                            <div className="text-danger"><ErrorMessage name="pais" /></div>
                                            {provincias.length === 0 && setProvincias(paises[formik.values.pais].regions)}
                                            {formik.touched.pais && !formik.errors.pais && formik.values.pais.length > 0 && setProvincias(paises[formik.values.pais].regions)}
                                        </div>
                                        <div className="form-group col-12 col-sm-4">
                                            <label htmlFor="provincia">{provincias.length > 0 ? "Seleccionar" : "Ingrese"} Provincia*</label>
                                            {provincias.length > 0 ?
                                                <Field name="provincia" as="select" className="form-control" disabled={disabled}>
                                                    {formik.values.provincia.length === 0 && <option value="">Provincia</option>}
                                                    {provincias.map((prov, i) => <option key={i} value={i}>{prov.name}</option>)}
                                                </Field>
                                                :
                                                <Field name="provincia" type="text" className="form-control" placeholder="provincia" disabled={disabled && (!!formik.values.localidad && formik.values.localidad.length > 0)} />
                                            }
                                            <div className="text-danger"><ErrorMessage name="provincia" /></div>
                                        </div>
                                        <div className="form-group col-12 col-sm-4">
                                            <label htmlFor="localidad">Ingresar Localidad*</label>
                                            <Field name="localidad" type="text" className="form-control" maxLength={value.maxLocalidad} placeholder="Localidad" disabled={disabled && (!!formik.values.localidad && formik.values.localidad.length > 0) } />
                                            <div className="text-danger"><ErrorMessage name="localidad" /></div>
                                        </div>
                                    </div>
                                    {verDomicilio ?
                                        <div className="row justify-content-center mb-3">
                                            {disabled && !!formik.values.localidad && formik.values.localidad.length > 0 ?
                                                <Editar setDisabled={setDisabled} setVerDomicilio={setVerDomicilio} />
                                                :
                                                <Continuar />
                                            }
                                        </div>
                                        :
                                        <div className="row justify-content-center mb-3">
                                            <Volver ultimoPaso={1} {...props} />
                                            <Continuar />
                                        </div>
                                    }
                                </>
                            </Form>
                        )}
                    </Formik>
                </>
            }
        </PreInscripcionUIConsumer >
    )
}

export default DatosPersonales;